import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import FullScreenLoader from "app/components/ListingPageLoader";
import { displayDateFun } from "app/utils/constants/functions";
import { useSelector } from "react-redux";

export default function ReceivePendingTable() {
  const {
    receivePendingOrder,
    receivePendingSummary,
    receivePendingTotal,
    loading,
  } = useSelector((state) => state.reportReducer);

  return (
    <>
      {loading && <FullScreenLoader />}
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow sx={{ bgcolor: "#202020", color: "white" }}>
              <TableCell sx={{ color: "white" }}>SR NO.</TableCell>
              <TableCell sx={{ color: "white" }}>Order No</TableCell>
              <TableCell sx={{ color: "white" }}>Order Date</TableCell>
              <TableCell sx={{ color: "white" }}>Client Name</TableCell>
              <TableCell sx={{ color: "white" }}>Job Work ID</TableCell>
              <TableCell sx={{ color: "white" }}>Item No</TableCell>
              <TableCell sx={{ color: "white" }}>Item Name</TableCell>
              <TableCell sx={{ color: "white" }}>Sub Item Name</TableCell>
              <TableCell sx={{ color: "white" }}>Fabric Code</TableCell>
              <TableCell sx={{ color: "white" }}>Status</TableCell>
              <TableCell sx={{ color: "white" }}>Job Work Issued Date</TableCell>
              <TableCell sx={{ color: "white" }}>CHALLAN DT</TableCell>
              <TableCell sx={{ color: "white" }}>RECEIVED DT</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {receivePendingOrder && receivePendingOrder.length > 0 ? (
              receivePendingOrder.map((row, i) => (
                <TableRow key={row.order_items_id || i}>
                  <TableCell>{i + 1}</TableCell>
                  <TableCell>{row?.order_no}</TableCell>
                  <TableCell>
                    {row?.order_date ? displayDateFun(row.order_date) : ""}
                  </TableCell>
                  <TableCell>{row?.order_client_name || ""}</TableCell>
                  <TableCell>{row?.order_item_job_work_id}</TableCell>
                  <TableCell>{row?.order_item_no}</TableCell>
                  <TableCell>{row?.order_item_name}</TableCell>
                  <TableCell>{row?.order_sub_item_name}</TableCell>
                  <TableCell>{row?.order_item_kc_fabric_code}</TableCell>
                  <TableCell>{row?.order_item_status}</TableCell>
                  <TableCell>
                    {row?.order_item_job_work_issued_date
                      ? displayDateFun(row.order_item_job_work_issued_date)
                      : ""}
                  </TableCell>
                  <TableCell>
                    {row?.challan_create_date
                      ? displayDateFun(row.challan_create_date)
                      : ""}
                  </TableCell>
                  <TableCell>
                    {row?.order_item_receiving_date
                      ? displayDateFun(row.order_item_receiving_date)
                      : ""}
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell
                  colSpan={13}
                  sx={{ textAlign: "center", fontWeight: "bold" }}
                >
                  Data not found
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {receivePendingSummary && receivePendingSummary.length > 0 && (
        <TableContainer component={Paper} sx={{ mt: 4, maxWidth: 520 }}>
          <Table size="small">
            <TableHead>
              <TableRow sx={{ bgcolor: "#202020" }}>
                <TableCell sx={{ color: "white", minWidth: 320 }}>ITEM NAME</TableCell>
                <TableCell sx={{ color: "white", width: 80 }}>QTY</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {receivePendingSummary
                .filter((item) => item.qty > 0)
                .map((item) => (
                <TableRow key={item.item_name}>
                  <TableCell>{item.item_name}</TableCell>
                  <TableCell>{item.qty}</TableCell>
                </TableRow>
              ))}
              <TableRow>
                <TableCell sx={{ fontWeight: "bold" }}>TOTAL</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>
                  {receivePendingTotal}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </>
  );
}
